import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { GoogleIdentityService } from './';
import { HttpClient } from '@angular/common/http';
import { GoogleIdentityService } from 'src/app/services/google-identity.service';

//CSak teszteléshez, az igazi a sima login-ba van intergrálva

@Component({
    selector: 'app-google-login',
    templateUrl: './google-login.component.html',
    styleUrls: ['./google-login.component.scss'],
    standalone: false
})
export class GoogleLoginComponent implements OnInit {
  @ViewChild('googleBtnContainer', { static: true }) buttonContainer!: ElementRef;
  token?: string;
  profile?: any;

  private clientId = '428702553049-h24vv7psvpmeoq50q5h1d49n7itjn599.apps.googleusercontent.com'; 

  constructor(private google: GoogleIdentityService, private http: HttpClient) {}

  async ngOnInit() {
    await this.google.load();
    this.google.initialize(this.clientId, (idToken: string) => {
      console.log('✅ Google token:', idToken);
      this.token = idToken;

      // Backend ellenőrzés
      // this.http.post('https://localhost:5001/api/auth/google', { token: idToken })
      //   .subscribe({
      //     next: (res) => console.log('✅ Backend validálta a tokent:', res),
      //     error: (err) => console.error('❌ Backend hiba:', err)
      //   });
    });

    this.google.renderButton(this.buttonContainer.nativeElement);
  }

  showOneTap() {
    this.google.prompt();
  }
}
